import { useMemo } from "react";
import { type TypedUseSelectorHook, useDispatch, useSelector } from "react-redux";

import {
  type AllResponseTypes,
  type ReduxState,
  type VerificationStore,
  type ViewModel,
} from "../types/types";
import { useStore } from "../store/useStore";

import { programStore, selectEffectiveProgramTheme, selectResponseOverride } from "./programStore";

export const useAppSelector: TypedUseSelectorHook<ReduxState> = useSelector;
export const useAppDispatch: () => VerificationStore["dispatch"] = useDispatch;

export const useProgramId = () => useAppSelector((state) => state.programId);
export const useProgramTheme = () => useStore(programStore, selectEffectiveProgramTheme);
// TODO: fix VerificationService type to use AllResponseType, and conditionally set ViewModel based on current step
export const useVerificationResponse = () => {
  const override = useStore(programStore, selectResponseOverride);
  const fromRedux = useAppSelector((state) => state.verificationResponse as AllResponseTypes);
  return useMemo(
    () => (override ? ({ ...fromRedux, ...override } as AllResponseTypes) : fromRedux),
    [fromRedux, override],
  );
};
export const useVerificationId = () => useVerificationResponse()?.verificationId;
export const useSegment = () => useVerificationResponse()?.segment;
export const useViewModel = <T extends ViewModel = ViewModel>() =>
  useAppSelector((state) => state.viewModel as T);
